export default __webpack_public_path__ + "static/media/Background_00165.0774b864.png";